import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import "@fontsource/inter";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";

// Create a theme instance.
const theme = createTheme({
  typography: {
    fontFamily:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  },
});

// Light theme
const lightTheme = createTheme({
  typography: {
    fontFamily:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  },
  // palette: {
  //   mode: 'light',
  //   primary: {
  //     main: '#e8e8e8', // Blue
  //   },
  //   secondary: {
  //     main: '#dc004e', // Pink
  //   },
  //   background: {
  //     default: '#ffffff', // White
  //     paper: '#f5f5f5', // Light gray
  //   },
  // },
});

// Dark theme
const darkTheme = createTheme({
  typography: {
    fontFamily:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  },
  // palette: {
  //   mode: 'dark',
  //   primary: {
  //     main: '#90caf9', // Light blue
  //   },
  //   secondary: {
  //     main: '#f48fb1', // Light pink
  //   },
  //   background: {
  //     default: '#121212', // Dark gray
  //     paper: '#1e1e1e', // Slightly lighter dark gray
  //   },
  // },
});

const isDarkMode = false;
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
